function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_8027",
  "data-name": "Gruppe 8027",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23450",
  "data-name": "Pfad 23450",
  d: "M170.137,72.759a7.076,7.076,0,0,1-.578-2.813,7.417,7.417,0,0,1,.071-1.018,7.016,7.016,0,0,1,.925-2.615,7.177,7.177,0,0,1,2.283-2.361.375.375,0,1,0-.4-.631,7.954,7.954,0,0,0-2.524,2.61,7.727,7.727,0,0,0-1.021,2.893,7.93,7.93,0,0,0-.08,1.125,7.823,7.823,0,0,0,.638,3.108,8.155,8.155,0,0,0,.614,1.152.375.375,0,1,0,.629-.407A7.19,7.19,0,0,1,170.137,72.759Z",
  transform: "translate(-165.898 -52.091)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23451",
  "data-name": "Pfad 23451",
  d: "M164.118,51.246a.376.376,0,0,0-.3-.687,10.33,10.33,0,0,0-6.157,8.827.376.376,0,0,0,.351.4h.024a.375.375,0,0,0,.374-.351A9.578,9.578,0,0,1,164.118,51.246Z",
  transform: "translate(-157.225 -42.188)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23452",
  "data-name": "Pfad 23452",
  d: "M160.216,28.383a.371.371,0,0,0,.238-.084A14.633,14.633,0,0,1,169.7,25a7.117,7.117,0,1,1,0,14.234.376.376,0,0,0,0,.752,7.869,7.869,0,0,0,0-15.737,15.389,15.389,0,0,0-9.723,3.468.377.377,0,0,0-.053.529A.384.384,0,0,0,160.216,28.383Z",
  transform: "translate(-158.923 -21.753)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23453",
  "data-name": "Pfad 23453",
  d: "M178.352,14.636a.417.417,0,0,0,.116-.018,17.112,17.112,0,0,1,5.336-.849,9.53,9.53,0,0,1,3.742.756h0c.207.087.407.182.6.282a.376.376,0,0,0,.34-.671c-.213-.109-.429-.209-.651-.3h0a10.3,10.3,0,0,0-4.033-.814,17.865,17.865,0,0,0-5.57.885.375.375,0,0,0,.118.731Z",
  transform: "translate(-173.026 -13.02)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23454",
  "data-name": "Pfad 23454",
  d: "M175.628,44.922a.375.375,0,0,0-.5.171,9.557,9.557,0,0,1-8.636,5.381,2.122,2.122,0,1,1,0-4.244,5.369,5.369,0,0,0,0-10.739,12.846,12.846,0,0,0-10.712,5.741.375.375,0,0,0,.625.416,12.1,12.1,0,0,1,10.087-5.405,4.62,4.62,0,0,1,0,9.24,2.873,2.873,0,0,0,0,5.745,10.3,10.3,0,0,0,9.307-5.8A.374.374,0,0,0,175.628,44.922Z",
  transform: "translate(-155.715 -30.494)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23455",
  "data-name": "Pfad 23455",
  d: "M234.675,26.9a10.379,10.379,0,0,0-1.523-2.181h0a10.1,10.1,0,0,0-.967-.934.375.375,0,0,0-.485.574,9.707,9.707,0,0,1,.9.867h0a9.625,9.625,0,0,1,1.414,2.026,9.518,9.518,0,0,1,1.085,4.44,9.679,9.679,0,0,1-.171,1.812.375.375,0,0,0,.3.438.368.368,0,0,0,.071.007.377.377,0,0,0,.369-.3,10.392,10.392,0,0,0-.987-6.744Z",
  transform: "translate(-214.701 -21.325)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23456",
  "data-name": "Pfad 23456",
  d: "M193.249,80.595a12.116,12.116,0,0,1-7.84,2.879,4.62,4.62,0,0,1-3.037-8.1.375.375,0,1,0-.494-.565,5.37,5.37,0,0,0,3.531,9.416,12.871,12.871,0,0,0,8.327-3.057.375.375,0,1,0-.487-.571Z",
  transform: "translate(-174.632 -60.998)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23457",
  "data-name": "Pfad 23457",
  d: "M191.618,119.592a14.643,14.643,0,0,1-4.3.643,7.054,7.054,0,0,1-4.224-1.39.375.375,0,1,0-.447.6,7.8,7.8,0,0,0,4.671,1.536,15.385,15.385,0,0,0,4.516-.674.376.376,0,1,0-.22-.718Z",
  transform: "translate(-176.544 -95.26)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_2137",
  "data-name": "Rechteck 2137",
  width: 0.747,
  height: 4.511,
  transform: "translate(8.377 8.151)",
  fill: "#ee2375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_23458",
  "data-name": "Pfad 23458",
  d: "M204.967,51.945c0-1.4-.671-2.255-2-2.255H201.45V54.2H202.9C204.314,54.2,204.967,53.294,204.967,51.945Zm-2.77,1.621V50.321h.647c.849,0,1.367.418,1.367,1.621s-.527,1.621-1.387,1.621H202.2Z",
  transform: "translate(-191.281 -41.537)",
  fill: "#ee2375"
}));

function SvgId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.146,
    height: 25.724,
    viewBox: "0 0 21.146 25.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.11dec50b.svg";
export { ForwardRef as ReactComponent };